export default __webpack_public_path__ + "static/soc-2-compliance-saas-provider-c6f3c229af7172f9b9560d21b19ffe03.jpg";